// extracted by mini-css-extract-plugin
export default {"container":"carModelPage-module__container--I8TIe","page":"carModelPage-module__page--sHLAx","car_model_content":"carModelPage-module__car_model_content--NTs3X"};